import { render, staticRenderFns } from "./OrderPaymentsDetailed.html?vue&type=template&id=5108e773&scoped=true&external"
import script from "./OrderPaymentsDetailed.js?vue&type=script&lang=js&external"
export * from "./OrderPaymentsDetailed.js?vue&type=script&lang=js&external"
import style0 from "./OrderPaymentsDetailed.scss?vue&type=style&index=0&id=5108e773&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5108e773",
  null
  
)

export default component.exports